import React, { useEffect, useState } from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete } from 'react-icons/ai';
import Select from 'react-select';
import axios from 'axios';
import ToastNotification from '../../../components/ToastNotification';
import ConfirmDialog from '../../../components/ConfirmDialog';



const PayheadAmt = () => {
    // ======useState=======
    const [employeeList, setEmployeeList] = useState([]);

    const [variablePayheadOptions, setVariablePayheadOptions] = useState([]);
    const [fixedPayheads, setFixedPayheads] = useState([]);


    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });

    const [showConfirm, setShowConfirm] = useState(false);
    const [confirmConfig, setConfirmConfig] = useState({
        message: '',
        onConfirm: () => { },
    });


    const [showForm, setShowForm] = useState(false);
    const [selectedPayheads, setSelectedPayheads] = useState([]);
    const [currentPayhead, setCurrentPayhead] = useState(null);

    const [finalData, setFinalData] = useState([]);

    // edit
    const [isEditing, setIsEditing] = useState(false);
    const [editingIndex, setEditingIndex] = useState(null);
    // search
    const [searchQuery, setSearchQuery] = useState('');



    const [formData, setFormData] = useState({
        empId: '',
        empName: '',
    });


    const [payheadOptions, setPayheadOptions] = useState([]);


    // =======handlers========
    const handleOpenForm = () => {
        // Avoid duplicates if already opened
        const fixedClones = fixedPayheads.map(ph => ({ ...ph }));
        setSelectedPayheads(fixedClones);
        setFormData({ empId: '', empName: '' });
        setShowForm(true);
        setIsEditing(false);
        setEditingIndex(null);
    };


    const handleAddPayhead = () => {
        if (currentPayhead && !selectedPayheads.some(ph => ph.value === currentPayhead.value)) {
            setSelectedPayheads([...selectedPayheads, { ...currentPayhead, amount: '' }]);
            setCurrentPayhead(null);
        }
    };

    const handleAmountChange = (index, value) => {
        const updated = [...selectedPayheads];
        updated[index].amount = value;
        setSelectedPayheads(updated);
    };

    const handleDeletePayhead = (index) => {
        setConfirmConfig({
            message: 'Are you sure you want to delete this PayHead?',
            onConfirm: () => {
                const updated = [...selectedPayheads];
                updated.splice(index, 1);
                setSelectedPayheads(updated);
                setShowConfirm(false);
            }
        });
        setShowConfirm(true);
    };


    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSave = async () => {

        if (!formData.empId || !formData.empName) {
            setToast({
                show: true,
                message: 'Please select Employee ID and ensure Employee Name is filled.',
                bg: 'danger'
            });
            return;
        }


        const totalSalary = selectedPayheads.reduce((sum, ph) => {
            const amt = parseFloat(ph.amount);
            return sum + (isNaN(amt) ? 0 : amt);
        }, 0);

        const newEntry = {
            id: isEditing ? finalData[editingIndex].id : finalData.length + 1,
            emp_id: formData.empId,
            emp_name: formData.empName,
            salary: totalSalary,
            payheads: selectedPayheads.map(ph => ({
                id: ph.id,
                name: ph.value,
                amount: ph.amount,
                fromMonth: ph.fromMonth || null,
                toMonth: ph.toMonth || null,
                refNo: ph.refNo || '',
                // isActive: ph.isActive || false
            }))
        };
        // console.log(newEntry);

        try {
            if (isEditing) {
                await axios.put(`https://api.skyguard.group/api/update-payhead-amount/${newEntry.emp_id}`, newEntry);
                setToast({ show: true, message: 'PayHead Amount updated successfully!', bg: 'success' });

                // console.log("Server response", res.data);
            } else {
                await axios.post('https://api.skyguard.group/api/add-payhead-amount', newEntry);
                setToast({ show: true, message: 'PayHead Amount saved successfully!', bg: 'success' });
            }
            fetchPayheadAmounts();

        } catch (error) {
            console.error('Error saving PayHead:', error);
            setToast({ show: true, message: 'Failed to save PayHead Amount.', bg: 'danger' });
            return;
        }

        if (isEditing) {
            const updated = [...finalData];
            updated[editingIndex] = newEntry;
            setFinalData(updated);
        } else {
            setFinalData([...finalData, newEntry]);
        }

        // Reset form
        setFormData({ empId: '', empName: '' });
        setSelectedPayheads([]);
        setShowForm(false);
        setIsEditing(false);
        setEditingIndex(null);
    };


    const handleEdit = (index) => {
        const entry = finalData[index];

        setFormData({
            empId: entry.emp_id,
            empName: entry.emp_name,
        });


        setSelectedPayheads(entry.payheads || []);

        setEditingIndex(index);
        setIsEditing(true);
        setShowForm(true);
    };


    
  
    const filteredData = finalData.filter(itm =>
        Object.values(itm).some(val =>
            String(val).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );



    const handleInnerChange = (index, field, value) => {
        const updated = [...selectedPayheads];
        updated[index][field] = value;
        setSelectedPayheads(updated);
    };
    // =======================apis===================
    // payhead
    const fetchPayheads = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-payhead');
            const data = res.data.result;
            // console.log(data);

            const seen = new Set();
            const variable = [];
            const fixed = [];

            data.forEach(ph => {
                if (!seen.has(ph.name)) {
                    seen.add(ph.name);
                    const formatted = {
                        id: ph.id,
                        value: ph.name,
                        label: ph.name,
                        amount: '',
                    };

                    if (ph.payHeadCategory === 'Variable') {
                        variable.push(formatted);
                    } else if (ph.payHeadCategory === 'Fixed') {
                        fixed.push(formatted);
                    }
                }
            });

            setVariablePayheadOptions(variable);
            setFixedPayheads(fixed);

        } catch (err) {
            console.error('Error fetching payheads:', err);
        }
    };


    // fetch Payhead amounts
    const fetchPayheadAmounts = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/get-payhead-amounts');
            if (res.data.success) {
                const parsedData = res.data.data.map(item => {
                    const payheads = (item.payheads || []).map(ph => ({
                        ...ph,
                        label: ph.name,
                        value: ph.name
                    }));

                    return {
                        ...item,
                        payheads
                    };
                });

                setFinalData(parsedData);
            }
        } catch (error) {
            console.error('Error fetching payhead amounts:', error);
        }
    }

    // delete
    const handleDeleteFinalEntry = (index) => {
        const empIdToDelete = finalData[index].emp_id;

        setConfirmConfig({
            message: `Are you sure you want to delete record for Employee ID: ${empIdToDelete}?`,
            onConfirm: async () => {
                try {
                    await axios.delete(`https://api.skyguard.group/api/delete-payhead-amount/${empIdToDelete}`);
                    setToast({ show: true, message: 'Deleted successfully!', bg: 'success' });
                    fetchPayheadAmounts();
                } catch (error) {
                    console.error('Error deleting PayHead Amount:', error);
                    setToast({ show: true, message: 'Failed to delete the record.', bg: 'danger' });
                }
                setShowConfirm(false);
            }
        });

        setShowConfirm(true);
    };


    // fetch-employee
    const fetchEmployeeData = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-employee');
            const data = res.data.result;
            // console.log(data);

            const formatted = data
             .filter(emp => emp.emp_id)   
            .map(emp => {
                const first = (emp.first || '').trim();
                const middle = (emp.middle || '').trim();
                const last = (emp.last || '').trim();

                const fullName = [first, middle, last].filter(Boolean).join(' ');
                return {
                    value: emp.emp_id,
                    label: emp.emp_id,
                    empName: fullName

                }
            });

            setEmployeeList(formatted);

        } catch (e) {
            console.error('Error fetching employee data:', e);
        }
    }


    useEffect(() => {
        fetchPayheads();
        fetchPayheadAmounts();
        fetchEmployeeData()
    }, [])



    // const emp_idOptions = [
    //     {value: 'EMP101', label: 'EMP101'},
    //     {value: 'EMP102', label: 'EMP102'},
    //     {value: 'EMP103', label: 'EMP103'}
    // ]



    return (
        <div className='main-section'>
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast(prev => ({ ...prev, show: false }))}
                />
                <h3 className='my-3 fw-bold fs-5 golos'>Monthwise Payhead Amount</h3>
                <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                    <div className="col-12 col-md-5">
                        <input
                            type="text"
                            className="form-control border border-0 border-bottom border-dark"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />

                    </div>
                    <div className="col-12 col-md-2 d-flex justify-content-end">
                        <button className='btn btn-success' onClick={handleOpenForm}>
                            <AiOutlinePlusCircle size={20} /> Add
                        </button>

                    </div>
                </div>

                {showForm && (
                    <div className='card p-3 my-3 shadow-sm bg-white border'>
                        <div className='row'>

                        {isEditing && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {formData.empId}
    </span>
  </div>
)}                          
                            <div className='col-md-6'>
                                <div className='row g-3'>
                                    <div className="col-12">
                                        <label className="form-label fw-medium">Employee ID</label>
                                        <Select
                                            options={employeeList}
                                            value={employeeList.find(opt => opt.value === formData.empId)}
                                            onChange={(selectedOption) => {
                                                if (!isEditing) {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        empId: selectedOption.value,
                                                        empName: selectedOption.empName,
                                                    }));
                                                }
                                            }}
                                            placeholder="Select Employee ID"
                                            isDisabled={isEditing}
                                        />

                                    </div>
                                    <div className="col-12">
                                        <label htmlFor="payhead" className="form-label fw-medium">Select PayHead To Add</label>
                                        <div className="d-flex gap-2">
                                            <div style={{ flex: 1 }}>
                                                <Select
                                                    options={variablePayheadOptions}
                                                    placeholder="Choose PayHead..."
                                                    value={currentPayhead}
                                                    onChange={setCurrentPayhead}
                                                />

                                            </div>
                                            <button className="btn btn-primary" onClick={handleAddPayhead}>Add</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='row g-3'>
                                    <div className="col-12">
                                        <label htmlFor="emp_name" className="form-label fw-medium">Employee Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="emp_name"
                                            name="empName"
                                            value={formData.empName}
                                            readOnly
                                            disabled={isEditing}
                                        />

                                    </div>

                                </div>
                            </div>
                        </div>

                        {/*Inner Table Section */}
                        <div className="table-responsive my-4">
                            <h5 className='golos text-center my-2'>Add PayHead & Amt...</h5>
                            <table className="table table-bordered text-center align-middle mx-auto">
                                <thead className="table-primary">
                                    <tr>
                                        <th>SN</th>
                                        <th>PayHead</th>
                                        <th>Enter Amount</th>
                                        <th>fromMonth</th>
                                        <th>toMonth</th>
                                        <th>Ref No</th>
                                        {/* <th>IsActive</th> */}
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedPayheads.map((ph, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td className='fw-medium golos'>{ph.label}</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control text-center"
                                                    placeholder='Enter Amount...'
                                                    value={ph.amount || ''}
                                                    onChange={(e) => handleAmountChange(index, e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="month"
                                                    className="form-control text-center"
                                                    value={ph.fromMonth || ''}
                                                    onChange={(e) => handleInnerChange(index, 'fromMonth', e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="month"
                                                    className="form-control text-center"
                                                    value={ph.toMonth || ''}
                                                    onChange={(e) => handleInnerChange(index, 'toMonth', e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control text-center"
                                                    placeholder='Ref No'
                                                    value={ph.refNo || ''}
                                                    onChange={(e) => handleInnerChange(index, 'refNo', e.target.value)}
                                                />
                                            </td>
                                            {/* <td>
                                                <input
                                                    type="checkbox"
                                                    className='form-check-input'
                                                    checked={ph.isActive || false}
                                                    onChange={(e) => handleInnerChange(index, 'isActive', e.target.checked)}
                                                />
                                            </td> */}
                                            <td>
                                                <button
                                                    className="btn btn-sm btn-danger"
                                                    onClick={() => handleDeletePayhead(index)}
                                                >
                                                    <AiOutlineDelete size={22} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                    {selectedPayheads.length === 0 && (
                                        <tr>
                                            <td colSpan="8" className='text-muted'>No PayHeads added yet.</td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                        </div>

                        {/* Buttons */}
                        <div className='gap-2 d-flex justify-content-center mt-4'>
                            <button type='button' className='btn btn-success w-10' onClick={handleSave}>
                                {isEditing ? 'Update' : 'Save'}
                            </button>
                            <button
                                type='button'
                                className='btn btn-danger w-10 ms-2'
                                onClick={() => {
                                    setShowForm(false);
                                    setFormData({ empId: '', empName: '' });
                                    setSelectedPayheads([]);
                                }}
                            >
                                Cancel
                            </button>

                        </div>
                    </div>
                )}
                {/*Outer Final Table */}
                <div className='table-responsive shadow p-3 mb-3 bg-body-tertiary rounded my-4'>
                    <table className='table table-bordered table-striped table-hover table-sm text-center align-middle'>
                        <thead className='table-info'>
                            <tr>
                                <th scope='col'>SN.</th>
                                     <th scope='col'>Action</th>
                                <th scope='col'>Emp ID</th>
                                <th scope='col'>Emp Name</th>
                                <th scope='col'>Salary</th>
                                {/* <th scope='col'>fromMonth</th>
                                <th scope='col'>toMonth</th>
                                <th scope='col'>refNo</th>
                                <th scope='col'>isActive</th> */}
                           
                            </tr>
                        </thead>
                        <tbody className='table-sm'>
                            {filteredData.map((itm, id) => (
                                <tr key={id}>
                                    <td>{id + 1}</td>
                                         <td>
                                        <button className='btn btn-primary mx-2' onClick={() => handleEdit(id)}>
                                            Edit
                                        </button>
                                        <button className='btn btn-danger' onClick={() => handleDeleteFinalEntry(id)}>
                                            <AiOutlineDelete size={20} />
                                        </button>
                                    </td>
                                    <td>{itm.emp_id}</td>
                                    <td>{itm.emp_name}</td>
                                    <td>{itm.salary}</td>
                                    {/* <td>
                                        {itm.payheads.map((ph, idx) => (
                                            <div key={idx}>{ph.fromMonth ? formatMonthYear(ph.fromMonth) : '—'}</div>
                                        ))}
                                    </td>
                                    <td>
                                        {itm.payheads.map((ph, idx) => (
                                            <div key={idx}>{ph.toMonth ? formatMonthYear(ph.toMonth) : '—'}</div>
                                        ))}
                                    </td>
                                    <td>
                                        {itm.payheads.map((ph, idx) => (
                                            <div key={idx}>{ph.refNo || '—'}</div>
                                        ))}
                                    </td>
                                    <td>
                                        {itm.payheads.map((ph, idx) => (
                                            <div key={idx}>{ph.isActive ? 'Yes' : 'No'}</div>
                                        ))}
                                    </td> */}

                               
                                </tr>
                            ))}
                            {filteredData.length === 0 && (
                                <tr>
                                    <td colSpan="9" className='text-muted'>No matching records found.</td>
                                </tr>
                            )}

                        </tbody>
                    </table>
                </div>
            </div>
            <ConfirmDialog
                show={showConfirm}
                message={confirmConfig.message}
                onConfirm={confirmConfig.onConfirm}
                onCancel={() => setShowConfirm(false)}
            />

        </div>
    );
};

export default PayheadAmt;